




























import { defineComponent, getCurrentInstance, ComponentInternalInstance, ref } from '@vue/composition-api';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import { LOCATION_MAP } from '@/common/reporter/utils';
export default defineComponent({
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    showRefresh: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, context) {
    const showTips = ref(false);
    const refresh = () => {
      showTips.value = false;
      context.emit('refresh');
      const currComponent: ComponentInternalInstance = getCurrentInstance() as ComponentInternalInstance;
      const vm = getCurrentInstance()?.proxy || context.root;
      reporter.report('list_refresh', {
        location: LOCATION_MAP[vm.$route.name as string],
      });
    };
    return {
      refresh,
      showTips,
    };
  },
});
